import { jwtDecode } from 'jwt-decode'
import api from '@api/index'
import { Extent } from '@models/api/Extent'

interface Token {
  user: {
    ID_USUARIO: number
    NOMBRE: string
    APELLIDO: string
    EMAIL: string
    ID_ROL: number
    NOMBRE_USUARIO: string
    PERMISOS: string[]
    ORGANIZATION: {
      ID: string
      EXTENT?: Extent
      DEFAULT_MODEL?: string
    }
  }
  iat: number
  exp: number
}

export const TokenService = {
  validateToken: async () => {
    let isValid = false
    try {
      isValid = (await api.auth.validate()).status === 200
    } catch (err) {
      isValid = false
    }
    return isValid
  },

  getTokenData: (rawToken: string): Token | undefined => {
    if (rawToken) {
      return jwtDecode<Token>(rawToken)
    }
  }
}
